import api from '../REST/api';
import withResolved from '../REST/with-resolved';

const withOpportunitiesAsData = (Component, options = {}) =>
  withResolved({
    query: api.getOpportunities,
    deriveQueryArgs: ({
      brandIds,
      ownerId,
      relevantFor,
      relevantForSalesTeam,
      agreementIds,
    }) => ({
      search: {
        brandIds,
        ownerId,
        relevantFor,
        relevantForSalesTeam,
        agreementIds,
        ...options,
      },
    }),
    as: 'data',
  })(Component);

export default withOpportunitiesAsData;
